import { AlbumFile } from '@/models/albumFile.ts'
import { PlaylistDoublePage } from '@/models/playlist.ts'

export interface Book {
  pages: Array<PlaylistDoublePage>
  page_width: number
  page_height: number
}

// export interface BookPage {
//   id: string
//   layout_id: string | null
//   order: number
//   width: number
//   height: number
//   // elements: Array<PageElement>
// }

export interface ElementTransform {
  id: string
  page: string
  // type: 'img' | 'text'
  order: number
  x: number
  y: number
  width: number
  height: number
  rotation: number

  crop_x: number
  crop_y: number
  crop_width: number
  crop_height: number
  crop_rotated: boolean
}

type AbsolutelyPlacedLayoutSlot = {
  id: string
  // page: string
  // type: 'img' | 'text'
  order: number
  x: number
  y: number
  width: number
  height: number
  rotation: number
}
export type PageLayoutSlot = AbsolutelyPlacedLayoutSlot
// | {
//   id: string
//   order: number
//   use_maximum_natural_size: true
//   offsetX: number
//   maxW: number
//   maxH: number
//   border: number
// }

export interface ImageTransform extends ElementTransform {
  kind: 'img'
  img: AlbumFile | null
}

export interface TextTransform extends ElementTransform {
  kind: 'text'
  text: string
}

export type PageElement = (ImageTransform | TextTransform)

export interface PageLayout {
  id: string
  slots: Array<PageLayoutSlot>
}
//
// function createFullSizeHalf(id: string, order: number, border: number, offsetX: number): PageLayoutSlot {
//   return {
//     id,
//     order,
//     use_maximum_natural_size: true,
//     offsetX,
//     maxW: 0.5,
//     maxH: 1,
//     border,
//   }
// }


function createAbsolutelyPositioned(id: string, order: number, x: number, y: number, width: number, height: number): PageLayoutSlot {
  return {
    id,
    order,
    x,
    y,
    width,
    height,
    rotation: 0,
  }
}

const DOUBLE_SIDE_SPINE_MAP_TO_MM: Record<string, number> = {
  '10': 5.6,
  '11': 6.1,
  '12': 6.5,
  '13': 7.0,
  '14': 7.4,
  '15': 7.9,
  '16': 8.4,
  '17': 8.8,
  '18': 9.3,
  '19': 9.7,
  '20': 10.2,
  '21': 10.7,
  '22': 11.1,
  '23': 11.6,
  '24': 12.0,
  '25': 12.5,
  '26': 13.0,
  '27': 13.4,
  '28': 13.9,
  '29': 14.3,
  '30': 14.8,
  '31': 15.3,
  '32': 15.7,
  '33': 16.2,
  '34': 16.6,
  '35': 17.1,
  '36': 17.6,
  '37': 18.0,
  '38': 18.5,
  '39': 18.9,
  '40': 19.4,
  '41': 19.9,
  '42': 20.3,
  '43': 20.8,
  '44': 21.2,
  '45': 21.7,
  '46': 22.2,
  '47': 22.6,
  '48': 23.1,
  '49': 23.5,
  '50': 24.0,
}

export function getSpineWidthForDoublePageCountInMm(pageCount: number): number {
  return DOUBLE_SIDE_SPINE_MAP_TO_MM[`${pageCount}`] ?? DOUBLE_SIDE_SPINE_MAP_TO_MM['50']
}

// CoverLayouts do not have the spine explicitly. If a value is <0.5, it's on the left (back). If it's over 0.5, it's on the right
// If a width crosses the spine, (e.g. x=0.2 and width=0.7) it'll be on both pages and the spine will just be added onto the width -> so it's 0.3 on back + dynamic spine ? 0.4 on the right side/front page
export const CoverLayouts: Array<PageLayout> = [
  {
    id: 'sq-2-2sq',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.45,
        0.9,
      )
    ],
  },
]


export const PageLayouts: Array<PageLayout> = [
  // {
  //   id: 'basic-full',
  //   slots: [
  //     createFullSizeHalf(
  //       '0',
  //       0,
  //       0.05,
  //       0,
  //     ),
  //     createFullSizeHalf(
  //       '1',
  //       1,
  //       0.05,
  //       0.5,
  //     ),
  //   ],
  // },
  {
    id: 'sq-2-2sq',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.45,
        0.9,
      )
    ],
  },
  {
    id: 'sq-2-lg-sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.65,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.65+2*0.025,
        0.05,
        1 -  3*0.025 - 0.65,
        0.9,
      )
    ],
  },
  {
    id: 'sq-2-sm-lg',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        1 - 3*0.025 - 0.65,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        1 - 0.025 - 0.65,
        0.05,
        0.65,
        0.9,
      )
    ],
  },
  {
    id: 'sq-1-lg',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.95,
        0.9,
      ),
    ],
  },
  {
    id: 'sq-3-eq',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.3,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.35,
        0.05,
        0.3,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.675,
        0.05,
        0.3,
        0.9,
      )
    ],
  },
  {
    id: 'sq-3-lg-sm-sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.7625,
        0.05,
        0.2125,
        0.9,
      )
    ],
  },
  {
    id: 'sq-3-sm-lg-sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.225,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.275,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.75,
        0.05,
        0.225,
        0.9,
      )
    ],
  },
  {
    id: 'sq-3-sm-sm-lg',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.2625,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.525,
        0.05,
        0.45,
        0.9,
      )
    ],
  },
  {
    id: 'sq-3-vertical',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.025,
        0.525,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.525,
        0.05,
        0.45,
        0.9,
      )
    ],
  },
  {
    id: 'sq-4-eq',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.2625,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.525,
        0.05,
        0.2125,
        0.9,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.7625,
        0.05,
        0.2125,
        0.9,
      )
    ],
  },
  {
    id: 'sq-4-grid-2x2',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.025,
        0.525,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.525,
        0.525,
        0.45,
        0.425,
      )
    ],
  },
  {
    id: 'sq-4-lg-3sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.45,
        0.275,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.525,
        0.3625,
        0.45,
        0.275,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.525,
        0.675,
        0.45,
        0.275,
      )
    ],
  },
  {
    id: 'sq-4-2lg-2sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.325,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.375,
        0.05,
        0.325,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.725,
        0.05,
        0.25,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.725,
        0.525,
        0.25,
        0.425,
      )
    ],
  },
  {
    id: 'sq-4-mixed-grid',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.35,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.675,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.025,
        0.525,
        0.95,
        0.425,
      )
    ],
  },
  {
    id: 'sq-4-1lg-3vertical',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.6,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.65,
        0.05,
        0.325,
        0.275,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.65,
        0.3625,
        0.325,
        0.275,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.65,
        0.675,
        0.325,
        0.275,
      )
    ],
  },
  {
    id: 'sq-5-2top-3bottom',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.025,
        0.525,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.35,
        0.525,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.675,
        0.525,
        0.3,
        0.425,
      )
    ],
  },
  {
    id: 'sq-5-3top-2bottom',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.35,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.675,
        0.05,
        0.3,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.025,
        0.525,
        0.45,
        0.425,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.525,
        0.525,
        0.45,
        0.425,
      )
    ],
  },
  {
    id: 'sq-5-1lg-4grid',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.45,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.525,
        0.05,
        0.225,
        0.425,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.775,
        0.05,
        0.2,
        0.425,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.525,
        0.525,
        0.225,
        0.425,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.775,
        0.525,
        0.2,
        0.425,
      )
    ],
  },
  {
    id: 'sq-5-2lg-3sm',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.375,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.425,
        0.05,
        0.375,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.825,
        0.05,
        0.15,
        0.275,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.825,
        0.3625,
        0.15,
        0.275,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.825,
        0.675,
        0.15,
        0.275,
      )
    ],
  },
  {
    id: 'sq-5-asymmetric',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.3,
        0.6,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.35,
        0.05,
        0.3,
        0.6,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.675,
        0.05,
        0.3,
        0.275,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.675,
        0.375,
        0.3,
        0.275,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.025,
        0.7,
        0.95,
        0.25,
      )
    ],
  },
  {
    id: 'sq-5-horizontal',
    slots: [
      createAbsolutelyPositioned(
        '0',
        0,
        0.025,
        0.05,
        0.175,
        0.9,
      ),
      createAbsolutelyPositioned(
        '1',
        1,
        0.225,
        0.05,
        0.175,
        0.9,
      ),
      createAbsolutelyPositioned(
        '2',
        2,
        0.425,
        0.05,
        0.15,
        0.9,
      ),
      createAbsolutelyPositioned(
        '3',
        3,
        0.6,
        0.05,
        0.175,
        0.9,
      ),
      createAbsolutelyPositioned(
        '4',
        4,
        0.8,
        0.05,
        0.175,
        0.9,
      )
    ],
  },
  // 6-slot layouts
  {
    id: 'sq-6-grid-3x2',
    slots: [
      // Top row - 3 images
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.3, 0.425),
      createAbsolutelyPositioned('1', 1, 0.35, 0.05, 0.3, 0.425),
      createAbsolutelyPositioned('2', 2, 0.675, 0.05, 0.3, 0.425),
      // Bottom row - 3 images
      createAbsolutelyPositioned('3', 3, 0.025, 0.525, 0.3, 0.425),
      createAbsolutelyPositioned('4', 4, 0.35, 0.525, 0.3, 0.425),
      createAbsolutelyPositioned('5', 5, 0.675, 0.525, 0.3, 0.425),
    ],
  },
  {
    id: 'sq-6-2top-4bottom',
    slots: [
      // Top row - 2 larger images
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.45, 0.425),
      createAbsolutelyPositioned('1', 1, 0.525, 0.05, 0.45, 0.425),
      // Bottom row - 4 smaller images
      createAbsolutelyPositioned('2', 2, 0.025, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('3', 3, 0.27, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('4', 4, 0.515, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('5', 5, 0.76, 0.525, 0.215, 0.425),
    ],
  },
  {
    id: 'sq-6-4top-2bottom',
    slots: [
      // Top row - 4 smaller images
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('1', 1, 0.27, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('2', 2, 0.515, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('3', 3, 0.76, 0.05, 0.215, 0.425),
      // Bottom row - 2 larger images
      createAbsolutelyPositioned('4', 4, 0.025, 0.525, 0.45, 0.425),
      createAbsolutelyPositioned('5', 5, 0.525, 0.525, 0.45, 0.425),
    ],
  },
  {
    id: 'sq-6-1lg-5grid',
    slots: [
      // Left - 1 large image
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.45, 0.9),
      // Right side - 2x2 grid + 1 wide at bottom
      createAbsolutelyPositioned('1', 1, 0.525, 0.05, 0.2, 0.275),
      createAbsolutelyPositioned('2', 2, 0.75, 0.05, 0.225, 0.275),
      createAbsolutelyPositioned('3', 3, 0.525, 0.3625, 0.2, 0.275),
      createAbsolutelyPositioned('4', 4, 0.75, 0.3625, 0.225, 0.275),
      createAbsolutelyPositioned('5', 5, 0.525, 0.675, 0.45, 0.275),
    ],
  },
  // 7-slot layouts
  {
    id: 'sq-7-3top-4bottom',
    slots: [
      // Top row - 3 images
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.3, 0.425),
      createAbsolutelyPositioned('1', 1, 0.35, 0.05, 0.3, 0.425),
      createAbsolutelyPositioned('2', 2, 0.675, 0.05, 0.3, 0.425),
      // Bottom row - 4 images
      createAbsolutelyPositioned('3', 3, 0.025, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('4', 4, 0.27, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('5', 5, 0.515, 0.525, 0.22, 0.425),
      createAbsolutelyPositioned('6', 6, 0.76, 0.525, 0.215, 0.425),
    ],
  },
  {
    id: 'sq-7-4top-3bottom',
    slots: [
      // Top row - 4 images
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('1', 1, 0.27, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('2', 2, 0.515, 0.05, 0.22, 0.425),
      createAbsolutelyPositioned('3', 3, 0.76, 0.05, 0.215, 0.425),
      // Bottom row - 3 images
      createAbsolutelyPositioned('4', 4, 0.025, 0.525, 0.3, 0.425),
      createAbsolutelyPositioned('5', 5, 0.35, 0.525, 0.3, 0.425),
      createAbsolutelyPositioned('6', 6, 0.675, 0.525, 0.3, 0.425),
    ],
  },
  {
    id: 'sq-7-1lg-6grid',
    slots: [
      // Left - 1 large image
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.35, 0.9),
      // Right side - 3x2 grid
      createAbsolutelyPositioned('1', 1, 0.4, 0.05, 0.18, 0.425),
      createAbsolutelyPositioned('2', 2, 0.605, 0.05, 0.18, 0.425),
      createAbsolutelyPositioned('3', 3, 0.81, 0.05, 0.165, 0.425),
      createAbsolutelyPositioned('4', 4, 0.4, 0.525, 0.18, 0.425),
      createAbsolutelyPositioned('5', 5, 0.605, 0.525, 0.18, 0.425),
      createAbsolutelyPositioned('6', 6, 0.81, 0.525, 0.165, 0.425),
    ],
  },
  {
    id: 'sq-7-2lg-5grid',
    slots: [
      // Left column - 2 larger images stacked
      createAbsolutelyPositioned('0', 0, 0.025, 0.05, 0.35, 0.425),
      createAbsolutelyPositioned('1', 1, 0.025, 0.525, 0.35, 0.425),
      // Right side - 5 images (2 top, 3 bottom)
      createAbsolutelyPositioned('2', 2, 0.4, 0.05, 0.27, 0.425),
      createAbsolutelyPositioned('3', 3, 0.695, 0.05, 0.28, 0.425),
      createAbsolutelyPositioned('4', 4, 0.4, 0.525, 0.18, 0.425),
      createAbsolutelyPositioned('5', 5, 0.605, 0.525, 0.18, 0.425),
      createAbsolutelyPositioned('6', 6, 0.81, 0.525, 0.165, 0.425),
    ],
  },
]

export const PageLayoutByCount: Record<number, Array<PageLayout>> = {}

for (const pageLayout of PageLayouts) {
  const len = pageLayout.slots.length
  const currentLayouts = PageLayoutByCount[len] || []
  currentLayouts.push(pageLayout)

  PageLayoutByCount[len] = currentLayouts
}
